import { styled, Typography } from '@ori-ui/mui';

import { TOP_AREA_BANNER_HEIGHT } from '../../../../constants';

export const Root = styled('a')(({ theme, onClick }) => ({
  color: theme.palette.offer.dark,
  cursor: onClick ? 'pointer' : 'default',
  display: 'flex',
  height: TOP_AREA_BANNER_HEIGHT,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

export const Title = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  padding: theme.spacing(1),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&:hover': {
    textDecoration: 'underline',
  },
}));
